export const BRAND = {
  name: 'KINDSTONE',
  fullName: 'KINDSTONE Cleaning Services',
  tagline: 'Premium Residential Cleaning',
  phoneDisplay: '(407) 794-0555',
  phoneHref: 'tel:+14077940555',
  smsDisplay: '(832) 800-4362',
  smsHref: 'sms:+18328004362',
  email: 'contact@kindstonecleaning.com',
  website: 'kindstonecleaning.com',
  location: 'Serving select Central Florida communities.',
  // Official Spanish campaign line — reserved for future Spanish-language marketing.
  campaignLine: 'Espacios más limpios, vidas más brillantes.',
};

export const IMAGES = {
  // Replace these placeholders with real KINDSTONE photography when available.
  hero: 'https://static.prod-images.emergentagent.com/jobs/aac6501e-4a8f-4e7b-956e-5d5a14949094/images/c785f2a2e2a834f1ccafaa6a4882873575099001f9433145b5083f751e05d0b6.jpeg',
  cleanerTowels:
    'https://images.pexels.com/photos/5591985/pexels-photo-5591985.jpeg?auto=compress&cs=tinysrgb&w=1200',
  livingRoom:
    'https://images.unsplash.com/photo-1649083048381-520a5b3d91ff?q=80&w=900&auto=format&fit=crop',
  kitchen:
    'https://images.unsplash.com/photo-1682888813913-e13f18692019?q=80&w=900&auto=format&fit=crop',
  bedroom:
    'https://images.unsplash.com/photo-1749703824872-3548e51ebdf2?q=80&w=900&auto=format&fit=crop',
  emptyRoom:
    'https://images.unsplash.com/photo-1762529716272-b316f61502e7?q=80&w=900&auto=format&fit=crop',
  towels:
    'https://images.unsplash.com/photo-1666934209606-a955a12edd63?q=80&w=900&auto=format&fit=crop',
  servicesBed:
    'https://images.pexels.com/photos/5591903/pexels-photo-5591903.jpeg?auto=compress&cs=tinysrgb&w=1200',
  emotionalLiving:
    'https://images.pexels.com/photos/5942742/pexels-photo-5942742.jpeg?auto=compress&cs=tinysrgb&w=1600',
};

// Real before-and-after photographs supplied for KINDSTONE; resized for efficient delivery.
export const INSPIRATION_GALLERY = [
  {
    id: 'kitchen', label: 'Kitchen',
    before: '/results/kitchen-before.webp', after: '/results/kitchen-after.webp',
    altAfter: 'Clean residential kitchen after service',
    heading: 'A freshly reset kitchen.',
    description: 'See the difference between a busy kitchen and a cleaner, more welcoming space.',
    accent: 'Care that makes a difference',
  },
  {
    id: 'bathroom', label: 'Bathroom',
    before: '/results/bathroom-before.webp', after: '/results/bathroom-after.webp',
    altAfter: 'Clean bathroom with a tidy dual vanity',
    heading: 'The little details matter.',
    description: 'A refreshed countertop and polished mirrors bring comfort back to an everyday space.',
    accent: 'Freshness you can see',
  },

];

export const NAV_LINKS = [
  { label: 'Services', id: 'services' },
  { label: 'Why KINDSTONE', id: 'why-kindstone' },
  { label: 'How It Works', id: 'how-it-works' },
  { label: 'Service Areas', id: 'service-areas' },
  { label: 'FAQ', id: 'faq' },
];

export const SERVICES = [
  {
    id: 'regular',
    name: 'Regular Cleaning',
    icon: 'repeat',
    image: 'livingRoom',
    alt: 'Bright, freshly cleaned living room with white sofas and natural daylight',
    description:
      'A consistent, thorough clean for lived-in homes — kitchens, bathrooms and living spaces kept fresh, visit after visit.',
  },
  {
    id: 'deep',
    name: 'Deep Cleaning',
    icon: 'sparkles',
    image: 'kitchen',
    alt: 'Immaculate modern kitchen with white cabinetry and marble island',
    description:
      'A top-to-bottom detailed clean that reaches the spots everyday routines miss. Ideal for a first visit or a seasonal reset.',
  },
  {
    id: 'move-in',
    name: 'Move-In Cleaning',
    icon: 'door',
    image: 'bedroom',
    alt: 'Bright bedroom with crisp white bedding and natural light',
    description:
      'Start fresh in your new space with a full clean before your boxes arrive — every surface ready for your family.',
  },
  {
    id: 'move-out',
    name: 'Move-Out Cleaning',
    icon: 'package',
    image: 'emptyRoom',
    alt: 'Bright, empty home interior with spotless wood floors',
    description:
      'Leave your previous home spotless for the next chapter — and for whoever comes next.',
  },
  {
    id: 'recurring',
    name: 'Recurring Cleaning',
    icon: 'calendar',
    image: 'towels',
    alt: 'Rolled white towels arranged on a freshly made bed',
    description:
      'Set a schedule that fits your life — weekly, every two weeks or monthly — and come home to a fresh space every time.',
  },
];

export const WHY_ITEMS = [
  {
    title: 'Attention to Detail',
    description: 'Corners, edges and the details that others rush past — cleaned with care.',
    icon: 'scan',
  },
  {
    title: 'Clear Communication',
    description: 'Friendly, organized and honest — you always know what to expect and who to talk to.',
    icon: 'chat',
  },
  {
    title: 'Professional Service',
    description: 'Courteous, respectful care for your home, your time and your privacy.',
    icon: 'user',
  },
  {
    title: 'Cleaning Tailored to Your Home',
    description: 'Every home is different. We shape each cleaning around your space, priorities and routine.',
    icon: 'home',
  },
];

export const STEPS = [
  {
    title: 'Request a Quote',
    description: 'Submit our short online form and tell us about your home.',
    icon: 'clipboard',
  },
  {
    title: 'We Contact You',
    description:
      'A KINDSTONE team member personally contacts you to understand your property and cleaning needs.',
    icon: 'phone',
  },
  {
    title: 'Schedule Your Cleaning',
    description: 'We confirm the service details and a cleaning date that works for you.',
    icon: 'calendar',
  },
  {
    title: 'Enjoy Your Home',
    description: 'Relax and enjoy a cleaner, fresher, cared-for space.',
    icon: 'heart',
  },
];

export const AREAS = [
  'Dr. Phillips / Bay Hill / Sand Lake',
  'Lake Buena Vista / Williamsburg',
  'Horizon West / Winter Garden',
  'Downtown Orlando',
  'Altamonte Springs / East Winter Park',
];

export const FAQS = [
  {
    q: 'What types of homes does KINDSTONE clean?',
    a: 'We focus on residential homes, apartments and townhomes across our select Central Florida communities.',
  },
  {
    q: 'How do I request a cleaning quote?',
    a: 'Complete the short quote form on this page or text us at (832) 800-4362. A KINDSTONE team member will personally contact you to discuss your needs.',
  },
  {
    q: 'What information do you need to provide a quote?',
    a: "Basic details like your location, property type, size and the type of cleaning you're looking for. A KINDSTONE team member will review everything with you during the quote process.",
  },
  {
    q: 'Do I need to be home during the cleaning?',
    a: "That's up to you. We'll discuss access arrangements with you when confirming your service.",
  },
  {
    q: 'Does KINDSTONE offer recurring cleaning?',
    a: 'Yes — you can request weekly, every-two-weeks or monthly service. A team member will help you choose the schedule that fits your home.',
  },
  {
    q: 'Can I request a move-in or move-out cleaning?',
    a: "Absolutely. Tell us about your move in the quote form and a KINDSTONE team member will recommend the right cleaning for your timeline.",
  },
];

export const FORM_OPTIONS = {
  propertyType: ['House', 'Townhome', 'Apartment / Condo', 'Other'],
  bedrooms: ['Studio / 0', '1', '2', '3', '4', '5+'],
  bathrooms: ['1', '1.5', '2', '2.5', '3', '3.5', '4+'],
  cleaningService: [
    'Regular Cleaning',
    'Deep Cleaning',
    'Move-In Cleaning',
    'Move-Out Cleaning',
    'Not Sure Yet',
  ],
  frequency: ['One-Time', 'Weekly', 'Every 2 Weeks', 'Monthly', 'Not Sure Yet'],
  bestTime: ['Morning', 'Afternoon', 'Evening', 'Any Time'],
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;

  if (id === 'quote') {
    // Use a measured position for the form card, including the fixed header.
    // A direct scroll avoids landing above the card on mobile browsers.
    const headerHeight = document.querySelector('header')?.getBoundingClientRect().height || 80;
    const top = Math.max(0, window.scrollY + el.getBoundingClientRect().top - headerHeight - 12);
    if (window.__lenis) {
      window.__lenis.scrollTo(top, { immediate: true, force: true });
    } else {
      window.scrollTo({ top, behavior: 'instant' });
    }
    return;
  }

  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -88 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};
